import { render, staticRenderFns } from "./DesignWrapper.vue?vue&type=template&id=609ab170&"
import script from "./DesignWrapper.vue?vue&type=script&lang=js&"
export * from "./DesignWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DesignWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports